// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Gallery_Contact__3gSO9","Contact__title":"Gallery_Contact__title__25cfE","Contact__p":"Gallery_Contact__p__1R2_Y"};